import styled from "styled-components";
import { Button, Table } from "semantic-ui-react";

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  background: #ffffff;
  padding-left: 250px;
`;

export const Content = styled.div`
  width: 90%;
  max-width: 1200px;
  margin: 6% auto;
`;

export const Title = styled.h1`
  width: 100%;
  margin: 0px auto 15px auto;
  padding-bottom: 5px;

  color: #000000;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);

  font-size: 28px;
  font-family: sans-serif;
  font-weight: 600;
`;

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  width: 100%;
  margin-bottom: 16px;
`;

export const SearchInput = styled.input`
  flex: 1;
  height: 38px;

  padding: 0.5em 1em;

  outline: 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-family: sans-serif;

  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
`;

export const SemanticTable = styled(Table)`
  th {
    font-size: 14px !important;
    font-family: sans-serif !important;
  }

  tr {
    font-size: 14px;
    font-family: sans-serif;
    text-align: left;

    :hover {
      background: rgba(34, 36, 38, 0.05);
    }
  }
`;

export const Thumb = styled.img`
  width: 96px;
  height: 36px;
  object-fit: contain;
  border: 1px solid #eaeaea;
  border-radius: 3px;
  background: #fafafa;
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  color: ${(p) => (p.active ? "#1a7f37" : "#7d7d7d")};
  background: ${(p) => (p.active ? "#dafbe1" : "#eaeaea")};
`;

export const ActionGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ActionButton = styled(Button)`
  background: none !important;
  border: none !important;
  padding: 6px !important;
  i {
    color: ${(p) =>
      p.intent === "delete"
        ? "#c53030"
        : p.intent === "activate"
        ? "#1a7f37"
        : "#4a90e2"} !important;
  }
`;

export const ModalForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 4px 0;
`;

export const FieldRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    font-size: 13px;
    font-weight: 600;
    color: #333;
  }

  input {
    height: 36px;
    padding: 0.5em 0.75em;
    border: 1px solid rgba(34, 36, 38, 0.15);
    border-radius: 4px;
    font-size: 13px;
    font-family: sans-serif;
  }
`;

export const UploadRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

export const UploadBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  label {
    font-size: 13px;
    font-weight: 600;
    color: #333;
  }

  .hint {
    font-size: 11px;
    color: #777;
  }

  .preview {
    width: 100%;
    max-height: 120px;
    object-fit: contain;
    border: 1px dashed #d0d0d0;
    border-radius: 4px;
    background: #fafafa;
  }
`;

export const ActiveSwitch = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #333;
  cursor: pointer;

  input {
    width: 16px;
    height: 16px;
    margin: 0;
    cursor: pointer;
  }
`;

export const EmptyState = styled.div`
  width: 100%;
  padding: 40px 20px;
  text-align: center;
  color: #777;
  font-size: 14px;
  background: #fafafa;
  border: 1px dashed #d0d0d0;
  border-radius: 4px;
`;
